import { join } from 'light-component';
import { Box } from '@common';
import * as Base from '@base';
import styles from '../style.module.less';
import { Highlighter } from '../../component';
import type { ReactElement } from 'react';
import type { ShotEyesAmountProps } from './types';

export function ShotEyesAmountViewMode(props: ShotEyesAmountProps): ReactElement {
  return (
    <Box className={styles.viewBox}>
      <Box className={join(styles.subject, styles.input)}>
        <Highlighter title={props.title} keyword={props.keyword} className={styles.title} />
      </Box>
      <Box className={join(styles.content, styles.inputContent)}>
        <Base.Input
          type='number'
          readOnly={true}
          value={props.value}
        />
      </Box>
    </Box>
  );
}
